// extracted by mini-css-extract-plugin
module.exports = {"getNewQuoteButton":"quote-module--get-new-quote-button--1rAW5"};